import XIcon from '@assets/icons/x.svg'
import { useTooltipStore } from '@store/common/useTooltipStore.js'
import { memo, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const TooltipIcon = ({ className = '' }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66667 12C9.61218 12 12 9.61218 12 6.66667C12 3.72115 9.61218 1.33333 6.66667 1.33333C3.72115 1.33333 1.33333 3.72115 1.33333 6.66667C1.33333 9.61218 3.72115 12 6.66667 12ZM6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333ZM6.66667 5.33333C7.03486 5.33333 7.33333 5.63181 7.33333 6V10C7.33333 10.3682 7.03486 10.6667 6.66667 10.6667C6.29848 10.6667 6 10.3682 6 10V6C6 5.63181 6.29848 5.33333 6.66667 5.33333ZM6.66667 4.66667C7.21895 4.66667 7.66667 4.21895 7.66667 3.66667C7.66667 3.11438 7.21895 2.66667 6.66667 2.66667C6.11438 2.66667 5.66667 3.11438 5.66667 3.66667C5.66667 4.21895 6.11438 4.66667 6.66667 4.66667Z"
      fill="currentColor"
    />
  </svg>
)

export const Tooltip = memo(({ tooltipKey, values }) => {
  const { t } = useTranslation()
  const activeKey = useTooltipStore((s) => s.activeKey)
  const onToggle = useTooltipStore((s) => s.onToggle)
  const onClose = useTooltipStore((s) => s.onClose)

  const ref = useRef(null)
  const isOpen = activeKey === tooltipKey
  const title = tooltipKey ? t(`tooltip.${tooltipKey}.title`, { defaultValue: '' }) : ''

  const content = tooltipKey
    ? t(`tooltip.${tooltipKey}.content`, { defaultValue: '', ...values })
    : ''

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose?.()
      }
    }
    document.addEventListener('mousedown', handleOutside)
    document.addEventListener('touchstart', handleOutside)

    return () => {
      document.removeEventListener('mousedown', handleOutside)
      document.removeEventListener('touchstart', handleOutside)
    }
  }, [])

  return (
    <div className="flex">
      <button
        type="button"
        aria-label={t('common.tooltipAlt')}
        className="text-navy-400 relative -top-[0.5px] inline-flex"
        onClick={() => onToggle(tooltipKey)}
      >
        <TooltipIcon />
      </button>
      {isOpen && (
        <div
          className="text-14 text-navy-900 tooltip-inner absolute left-1/2 z-10 mt-2 w-2/3 min-w-[295px] -translate-x-1/2 rounded bg-white px-16 py-24 leading-5"
          ref={ref}
        >
          <div className={'mb-8 flex items-center justify-between'}>
            <strong>{title}</strong>
            <img
              src={XIcon}
              alt={t('common.close')}
              width={10}
              onClick={onClose}
              decoding="async"
            />
          </div>
          <p>{content}</p>
        </div>
      )}
    </div>
  )
})
